<style scoped>
.buGp {
    display: flex;
    justify-content: flex-end;
    margin-top: 40px;
}
</style>
<template>
    <section class="margin-layout">
        <div>
            {{
                $t("global.inbound.sendGood", {
                    defaultValue:
                        "确认实际发货数量与计划数量是否一致，如有短溢装情况请修改装箱信息",
                })
            }}
        </div>
        <ButtonGroup class="buGp">
            <Button type="primary" @click="changeBox" class="margin-right-5">{{
                $t("fbb.sendgood.Modify_packing", { defaultValue: "修改装箱" })
            }}</Button>
            <Button
                @click="confirm"
                class="margin-right-5"
                style="border-color: #dcdee2"
                >{{
                    $t("fbb.sendgood.Confirm_shipment", {
                        defaultValue: "确认发货",
                    })
                }}</Button
            >
            <Button @click="cancel">{{
                $t("global.common.return", { defaultValue: "返回" })
            }}</Button>
        </ButtonGroup>
        <compModal
            v-model="modalProps.show"
            v-bind="modalProps"
            @on-close="closemodalprops"
            @on-confirm="confirm"
        >
            <component
                v-if="modalProps.component"
                :is="modalProps.component"
                v-bind="modalProps"
                v-on="modalProps.on"
                @on-close="closemodalprops"
            />
        </compModal>
    </section>
</template>
<script>
export default {
    data() {
        return {
            modalProps: {
                show: false,
            },
        };
    },
    methods: {
        closemodalprops() {
            this.$emit("on-openCloseable");
            this.modalProps = {};
        },
        cancel() {
            this.$emit("on-cancel");
        },
        changeBox() {
            this.$emit("on-changeBox");
        },
        confirm() {
            this.$emit("on-closeCloseable");
            this.modalProps = {
                show: true,
                title: this.$t("global.common.update_OK", {
                    defaultValue: "确认",
                }),
                alert: "primary",
                desc: this.$t("fbb.inbound.confirm_updateversion", {
                    defaultValue: "请核对并确认箱标更新为最新版本！",
                }),
                width: 460,
                ajaxRequest: async () => {
                    this.$emit("on-confirm");
                },
            };
        },
    },
};
</script>
